import getPropertyIconPerItemClass, { noteClassPropertyIconMap, } from './getPropertyIconPerItemClass';
import PropertyIcons from './PropertyIcons';
function isMeetingType(itemType) {
    return itemType.toLowerCase().indexOf('ipm.schedule.meeting') != -1;
}
export default function getItemClassIcon(itemClasses, iconIndex, hasIrm) {
    if (hasIrm) {
        switch (iconIndex) {
            case 'MailReplied':
                iconIndex = 'MailIrmReplied';
                break;
            case 'MailForwarded':
                iconIndex = 'MailIrmForwarded';
                break;
            default:
                iconIndex = 'MailIrm';
                break;
        }
    }
    // Check to see if all item classes correspond to meeting requests
    var foundNonMeetingTypeClass = false;
    if (itemClasses) {
        var numberOfItemClasses = itemClasses.length;
        if (numberOfItemClasses == 1) {
            return getPropertyIconPerItemClass(itemClasses[0], iconIndex);
        }
        else {
            // Find a conversation icon to use.
            for (var i = 0; i < numberOfItemClasses; i++) {
                if (!isMeetingType(itemClasses[i])) {
                    foundNonMeetingTypeClass = true;
                    break;
                }
            }
        }
    }
    return foundNonMeetingTypeClass
        ? noteClassPropertyIconMap[iconIndex ? iconIndex.toString() : null]
        : PropertyIcons.MailListViewAppointmentItem;
}
//# sourceMappingURL=getItemClassIcon.js.map